import { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OfferBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/banner`).then((r) => setBanner(r.data)).catch(() => {});
  }, []);

  const text = banner?.active_text || banner?.text;
  if (!banner?.enabled || !text) return null;

  return (
    <div data-testid="offer-banner" className="relative z-30 bg-[#FFFFFF] text-black pt-[72px]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex items-center justify-center gap-3">
        <Megaphone size={14} className="shrink-0" />
        <p data-testid="offer-banner-text" className="text-xs sm:text-sm font-medium tracking-wide text-center">
          {text}
        </p>
      </div>
    </div>
  );
}
